import { useRef, useEffect } from 'react';
export function useMount(callback) {
    const isMounted = useRef(false);
    useEffect(() => {
        if (!isMounted.current) {
            const clean = callback();
            isMounted.current = true;
            return clean;
        }
        return () => { };
    }, []);
}
export function fixNegativeIndex(index, totalItems) {
    if (index === -1) {
        return totalItems - 1;
    }
    if (index >= totalItems) {
        return 0;
    }
    return index;
}
